<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="24px" v-bind="attrs" v-on="on" @click="setData">mdi-magnify</v-icon>
      </template>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline grey--text text--darken-4">Detalhes do canal</span>
                  <v-icon size="24px" class="pointer" @click="dialog = false">mdi-close</v-icon>
                </div>
              </v-col>
              <v-col cols="12" class="green darken-2 pa-5 text-center" v-if="this.channel.is_authorized">
                <span
                  class="white--text"
                >Canal autorizado pelo usuário com sucesso</span>
              </v-col>
              <v-col cols="12" class="red lighten-1 pa-5 text-center d-flex justify-space-between" v-else>
                <span
                  class="white--text"
                >Canal ainda não autorizado pelo usuário</span>
                <span class="white--text pointer" @click="authChannel(channel.id_youtube_channel)">Reenviar Pedido</span>
              </v-col>
            </v-row>
            <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                     label="Nome do canal" v-model="name" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="pickerBought"
                    v-model="pickerBought"
                    :close-on-content-click="false"
                    :return-value.sync="boughtAt"
                    transition="scale-transition"
                    offset-y
                    class="fluid"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field

                        v-model="dateFormat"
                        label="Data da aquisição"
                        :rules="[rules.required]"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="boughtAt"
                      no-title
                      scrollable
                      locale="pt-BR"
                      :max="moment().format('YYYY-MM-DD')"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="pickerBought = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.pickerBought.save(boughtAt)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    @keydown="onlyNumbers($event)"
                    label="Valor de compra do canal"
                    v-model="price"
                    type="text"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    ref="pickerCreate"
                    v-model="pickerCreate"
                    :close-on-content-click="false"
                    :return-value.sync="boughtAt"
                    transition="scale-transition"
                    offset-y
                    class="fluid"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field

                        v-model="dateFormatCreate"
                        label="Data da criação do canal"
                        readonly
                        :rules="[rules.required]"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="createAt"
                      no-title
                      scrollable
                      locale="pt-BR"
                      :max="moment().format('YYYY-MM-DD')"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="pickerCreate = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.pickerCreate.save(boughtAt)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                     label="Page ID" v-model="pageId" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field

                    label="ID do canal no Youtube"
                    v-model="idYoutube"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select

                    v-model="categorySelected"
                    :items="categorys"
                    item-text="color"
                    item-value="id"
                    label="Categoria do canal"
                    :rules="[rules.required]"
                  >
                    <template v-slot:item="{ item }">
                      <div v-if="item.color == 'Sem Categoria'">
                        <v-icon color="black" size="12" class="mr-2">
                          mdi-checkbox-blank-circle
                        </v-icon>
                        <span>Sem categoria</span>
                      </div>
                      <div v-if="item.color == 'Verde'">
                        <v-icon color="green" size="12" class="mr-2">mdi-checkbox-blank-circle</v-icon>
                        <span>Verde</span>
                      </div>
                      <div v-if="item.color == 'Amarelo'">
                        <v-icon color="yellow" size="12" class="mr-2">mdi-checkbox-blank-circle</v-icon>
                        <span>Amarelo</span>
                      </div>
                      <div v-if="item.color == 'Vermelho'">
                        <v-icon color="red" size="12" class="mr-2">mdi-checkbox-blank-circle</v-icon>
                        <span>Vermelho</span>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <!-- <v-col cols="6">
                    <v-text-field label="Receita Bruta" v-model="grossRevenue" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Receita Líquida" v-model="netRevenue" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                  </v-col> -->
                  <v-col cols="6">
                    <v-select
                      v-model="businessRuleSelected"
                      :items="businessRules"
                      item-text="name"
                      item-value="id_youtube_channel_split_rule"
                      label="Regra de negócio"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" v-if="businessRuleSelected == 2">
                    <v-text-field label="Porcentagem 1BM" v-model="percentage1bmg" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                  </v-col>
                  <v-col cols="6" v-if="businessRuleSelected == 4"></v-col>
                  <v-col v-if="businessRuleSelected == 3" cols="6">
                    <v-text-field label="1BM" v-model="guaranteedMinimum.price" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                  </v-col>
                  <v-col v-if="businessRuleSelected == 3" cols="6">
                    <v-text-field label="Teto de Receita do Canal" v-model="guaranteedMinimum.revenueCeiling" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                  </v-col>
                  <v-col v-if="businessRuleSelected == 3" cols="6">
                    <v-text-field label="Porcentagem 1BM ao atingir o teto" v-model="guaranteedMinimum.porcentageCeiling" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                  </v-col>

                  <template v-if="businessRuleSelected == 4"> 
                    <div v-for="(item, index) in variablePercentage" :key="index" class="d-flex fluid flex-wrap">
                      <v-col cols="6">
                        <v-text-field label="Teto de Receita do Canal" v-model="item.revenueCeiling" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                      </v-col>
                      <v-col cols="6" class="d-flex align-center">
                        <v-text-field label="Porcentagem 1BM" v-model="item.percentage1bmg" type="number" :rules="[rules.required]" @keydown="onlyNumbers($event)"></v-text-field>
                        <div @click="variablePercentage.splice(index, 1)" class="pointer">
                          <v-icon color="red" class="ml-2">mdi-delete-circle</v-icon>
                        </div>
                      </v-col>
                    </div>
                    <div>
                    <v-col cols="12" class="d-flex align-center">
                      <v-text-field
                        label="Porcentagem 1BMG final"
                        v-model="lastPercentage1bmg"
                        type="number"
                        :rules="[rules.required]"
                        @keydown="onlyNumbers($event)"
                      ></v-text-field>
                    </v-col>
                  </div>
                    <v-col cols="12" class="d-flex justify-end align-center">
                      <div @click="variablePercentage.push({revenueCeiling: 0, percentage1bmg: 0})" class="pointer">
                        <v-icon color="#a1a1a1" class="mr-2">mdi-plus-circle</v-icon>
                        <span>Adicionar nova regra de porcentagem</span>
                      </div>
                    </v-col>
                  </template>
                </v-row>
              <v-row>
                <v-col>
                  <div class="d-flex align-center justify-space-between">
                    <span class="body-2 grey--text text--darken-4">Este canal possui grupo de assets em um CMS?</span>
                    <v-switch v-model="cms" @change="getCms" ></v-switch>
                  </div>
                  <div class="line my-3"></div>
                </v-col>
              </v-row>
              <v-row v-if="cms">
                <v-col cols="12" class="grey darken-3 pa-5 text-center">
                  <span class="white--text">Atenção, você deve cadastrar um CMS previamente para continuar.</span>
                </v-col>
                <div v-for="(cmsItem, index) in cmsGroup" :key="index" class="d-flex align-center fluid">
                  <v-col cols="6">
                    <v-text-field label="ID grupo de assets" v-model="cmsItem.assets_group_id_youtube" :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-space-between">
                    <v-select
                        v-model="cmsItem.id_youtube_cms"
                        :items="idCmsList"
                        item-text="name"
                        item-value="id"
                        label="ID do CMS"
                        :rules="[rules.required]"
                    >
                    </v-select>
                    <v-icon color="red" class="ml-4 pointer" @click="removePosition(index)" v-if="index > 0">mdi-delete</v-icon>
                  </v-col>
                </div>
                <v-col cols="12">
                  <div class="d-flex align-center pointer" @click="addPosition">
                    <v-icon color="#1591ea">mdi-plus-circle</v-icon>
                    <span class="ml-2 light-blue--text text--darken-3 body-1">Adicionar outro grupo de assets à este canal</span>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center flex-wrap align-center">
          <v-spacer class="d-none d-md-block"></v-spacer>
          <v-btn
            v-if="!deleteConfirm"
            color="#ef5350"
            class="button-primary mb-4"
            @click="deleteConfirm = true"
            dark
          >
            <span>Excluir canal</span>
          </v-btn>
          <v-btn v-else color="#ef5350" class="mb-4" @click="deleteChannel()" dark>
            <span>CONFIRMAR EXCLUSÃO</span>
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="#fed602"
            @click="updateChannel()"
            class="button-primary mr-2 mb-4"
          >
            <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
            <span v-else>Salvar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    channel: {
      type: Object,
      required: true,
      default: null,
    }
  },
  computed: {
    dateFormat: function () {
      return  this.boughtAt ? moment(this.boughtAt).format('DD-MM-YYYY') : ''
    },
    dateFormatCreate: function () {
      return  this.createAt ? moment(this.createAt).format('DD-MM-YYYY') : ''
    }
  },
  data: () => ({
    moment: moment,
    name: '',
    price: '',
    pickerCreate: false,
    createAt: '',
    pickerBought: false,
    boughtAt: '',
    pageId: '',
    categorySelected: '',
    categorys: [
      {id: 'without_category', color: 'Sem Categoria'},
      {id: 'green', color: 'Verde'},
      {id: 'red', color: 'Vermelho'},
      {id: 'yellow', color: 'Amarelo'}
    ],
    cms: false,
    cmsGroup: [
      {
        id_youtube_cms: '',
        assets_group_id_youtube: ''
      }
    ],
    idGroupAssets: '',
    idYoutube: '',
    idCmsSelected: '',
    idCmsList: [],
    deleteConfirm: false,
    loading: false,
    notification: {
        active: false,
        description: '',
        type: '',
        closeText: ''
    },
    valid: true,
    rules: {
        required: value => !!value || 'Este campo é obrigatório.',
        min: v => v.length >= 6 || 'Sua senha precisa ter pelo menos 6 caracteres',
        email: v => /.+@.+\..+/.test(v) || 'E-mail inválido'
    },
    dialog: false,
    businessRules: [],
    // grossRevenue: 0,
    // netRevenue: 0,
    businessRuleSelected: null,
    guaranteedMinimum : {},
    fixedPercentage: 0,
    percentage1bmg: 0,
    variablePercentage: [{
      revenueCeiling: 0,
      percentage1bmg: 0
    }],
    lastPercentage1bmg: 0
  }),
  methods: {
    getBusinessRules() {
      this.$http.get( '/channel/split-rules' )
      .then( (res) => {
        this.businessRules = res.data;
      })
      .catch( () => {
        this.notification = {
          active: true,
          description: 'Houve um erro na solicitação.',
          type: 'error',
          closeText: 'Fechar'
        },
        this.$emit( 'notification', this.notification );
      })
    },
    setData() {
      this.getBusinessRules();
      const params = JSON.parse(this.channel.split_rule);

      this.name = this.channel.name;
      this.price = String(this.channel.price).replace('.',',');
      this.createAt = this.channel.created_on_youtube_at;
      this.boughtAt = this.channel.bought_at;
      this.pageId = this.channel.page_id;
      this.categorySelected = this.channel.channel_group ? this.channel.channel_group : 'without_category';
      this.idYoutube = this.channel.channel_id_youtube;
      this.businessRuleSelected = this.channel.id_youtube_channel_split_rule;
      // this.grossRevenue = params.grossRevenue;
      // this.netRevenue = params.netRevenue;

      if (this.businessRuleSelected == 2) {
        this.percentage1bmg = params.percentage1bmg 
      }

      if (this.businessRuleSelected == 3) {
        this.guaranteedMinimum = params.guaranteedMinimum
      }

      if (this.businessRuleSelected == 4) {
        let lastValues = params.variablePercentage.pop()
        this.lastPercentage1bmg = lastValues.percentage1bmg
        console.log(this.lastPercentage1bmg)
        this.variablePercentage = params.variablePercentage
      }

      if (this.channel.assets_groups.length > 0) {
        this.cms = true;
        this.cmsGroup = this.channel.assets_groups
      }
      this.getCms();
    },
    getCms() {
      this.$http.get( '/cms' )
      .then( ( res ) => {
        this.idCmsList = res.data.map( cms => {
          return {
            name: cms.name,
            id: cms.id_youtube_cms
          }
        });
      } ).catch( () => {
        this.notification = {
          active: true,
          description: 'Houve um erro na solicitação.',
          type: 'error',
          closeText: 'Fechar'
        },
        this.$emit( 'notification', this.notification );
      } ).finally( () => {
        this.loading = false;
      } );
    },
    updateChannel() {
      const params = {
        // grossRevenue: this.grossRevenue,
        // netRevenue: this.netRevenue
      };

      if (this.businessRuleSelected == 2) {
        params.percentage1bmg = this.percentage1bmg;
      }

      if (this.businessRuleSelected == 3) {
        params.guaranteedMinimum = this.guaranteedMinimum;
      }

      if (this.businessRuleSelected == 4) {
        this.variablePercentage.push({
          revenueCeiling: 99e6.toString(),
          percentage1bmg: this.lastPercentage1bmg,
        });
        params.variablePercentage = this.variablePercentage;
      }

      const paramParse = JSON.stringify(params);

      this.$http.put( '/channel/' + this.channel.id_youtube_channel, {
        name: this.name,
        channel_id_youtube: this.idYoutube,
        bought_at: this.boughtAt,
        assets_groups: this.cms ? this.cmsGroup : null,
        price: this.price.replace(',','.'),
        created_on_youtube_at: this.createAt,
        page_id: this.pageId,
        channel_group: this.categorySelected,
        id_youtube_channel_split_rule: this.businessRuleSelected,
        split_rule: paramParse
      })
      .then( () => {
        this.notification = {
          active: true,
          description: 'Canal editado com sucesso.',
          type: 'success',
          closeText: 'Fechar'
        },
        this.$emit( 'notification', this.notification );
      })
      .catch(() => {
        (this.notification = {
          active: true,
          description: "Houve um erro ao editar este canal, tente novamente.",
          type: "error",
          closeText: "Fechar",
        }),
          this.$emit("notification", this.notification);
      })
      .finally(() => {
        (this.loading = false),
          (this.valid = true),
          (this.dialog = false),
          (this.deleteConfirm = false),
          this.$emit("getData");
      });
    },
    authChannel(channel) {
      this.$http.post( '/youtube-auth', {
        id_youtube_channel: channel,
      })
      .then( (res) => {
        window.open(res.data.url, "authwindow", "height=580,width=620")
      })
    },
    deleteChannel() {
      this.$http
        .delete("/channel/" + this.channel.id_youtube_channel)
        .then(() => {
          (this.notification = {
            active: true,
            description: "Canal excluído com sucesso.",
            type: "success",
            closeText: "Fechar",
          }),
            this.$emit("notification", this.notification);
        })
        .catch(() => {
          (this.notification = {
            active: true,
            description: "Houve um erro ao excluir este canal, tente novamente.",
            type: "error",
            closeText: "Fechar",
          }),
            this.$emit("notification", this.notification);
        })
        .finally(() => {
          (this.loading = false),
            (this.valid = true),
            (this.dialog = false),
            (this.deleteConfirm = false),
            this.$emit("getData");
        });
    },
    addPosition() {
      this.cmsGroup.push({
        idGroupAssets: '',
        idCmsSelected: ''
      })
    },
    onlyNumbers(e) {
      var charCode = e.keyCode;
      if (charCode != 8 && charCode != 9) {
        if (charCode != 188 && (charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 106)) {
          e.preventDefault();
        }
        if (charCode == 188 && this.value.indexOf(',') != -1 ) {
          e.preventDefault();
        }
      }
    },
    removePosition(position) {
      this.cmsGroup.splice(position, 1)
    },
  },
};
</script>